module.exports = __webpack_public_path__ + "static/media/jonathan.50d0b85f.png";